import type { IsoImplementationTaskStatus } from './types';

export const ROLE_LABELS: Record<string, string> = {
  iso: 'Consultor ISO',
  dir: 'Dirección',
  joint: 'Conjunto',
};

export const STATUS_LABELS: Record<IsoImplementationTaskStatus, string> = {
  pending: 'Pendiente',
  in_progress: 'En progreso',
  completed: 'Completado',
  not_applicable: 'No aplica',
};

export function isTaskDone(status: IsoImplementationTaskStatus): boolean {
  return status === 'completed' || status === 'not_applicable';
}

export function roleBadgeClass(role: string | null): string {
  if (role === 'iso') return 'bg-emerald-100 text-emerald-800';
  if (role === 'dir') return 'bg-blue-100 text-blue-800';
  if (role === 'joint') return 'bg-orange-100 text-orange-800';
  return 'bg-muted text-muted-foreground';
}

export function progressBarClass(percent: number): string {
  if (percent >= 80) return 'bg-emerald-600';
  if (percent >= 40) return 'bg-amber-500';
  return 'bg-slate-400';
}
